// extracted by mini-css-extract-plugin
module.exports = {"SkipNavigation":"SkipNavigation_SkipNavigation__RSbSd","In":"SkipNavigation_In__c-HIK"};